import { isNullCondition } from "./isNullCondition";

export function getInputValuesFromGivenCondition(conditionNode) {
  if (isNullCondition(conditionNode)) {
    return {};
  }
  if (conditionNode.isSingleOperand() === true) {
    return {
      [conditionNode.getAttributeName()]: conditionNode.getValue(),
    };
  } else {
    let result = {};
    conditionNode.getOperands().forEach((operand) => {
      result = { ...result, ...getInputValuesFromGivenCondition(operand) };
    });
    return result;
  }
}
